/**
 * Push data to the bucket of data for Google Tag Manager to read
 *
 * @param data - Data to push to the dataLayer
 */
export function pushToDataLayer(data: unknown): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
